@if (initialized) {
  <form [formGroup]="form">
    <rask-page pageTitle="{{ texts.rubik }}">
      <ng-container header>
        <rask-action-button aid="buttonRadera" icon="far fa-trash-alt" (click)="tabort()" [disabled]="isNew || !canEdit()">Ta bort</rask-action-button>
      </ng-container>
      <ng-container headerContent>
        @if (!isSvenskMottagningsplats()) {
          <rask-mottagningsplats-detaljer-header
            [mottagningsplats]="mottagningsplats"
            [rootForm]="form"
            [isNew]="isNew">
          </rask-mottagningsplats-detaljer-header>
        }
        @if (isSvenskMottagningsplats()) {
          <rask-mottagningsplats-detaljer-header-sv
            [mottagningsplats]="mottagningsplats"
            (lagerplatserChanged)="lagerplatserChanged($event)"
            [rootForm]="form"
            [isNew]="isNew"
          ></rask-mottagningsplats-detaljer-header-sv>
        }
        <div class="action-button-wrapper">
          <rask-action-button
            (click)="addAvlastningsplats()"
            icon="far fa-plus"
            [disabled]="!canAddAvlastningsplats">
            Lägg till avlastningsplats
          </rask-action-button>
        </div>
      </ng-container>
      @for (lagerplats of mottagningsplats.lagerplatser; track lagerplats) {
        <rask-container-block>
          <rask-mottagningsplats-detaljer-plats
            [mottagningsplats]="mottagningsplats"
            [lagerplats]="lagerplats"
            [rootForm]="form"
            #platser
          ></rask-mottagningsplats-detaljer-plats>
        </rask-container-block>
      }
      <ng-container footerContent>
        <rask-save-button aid="buttonSave" (click)="save()" [disabled]="!validForSave"></rask-save-button>
      </ng-container>
    </rask-page>
  </form>
}
